module.exports = __webpack_public_path__ + "932392df40911352b9b8382d5f01477b.jpg";